var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSadFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77778 9.22222C9.77778 10.1427 9.03159 10.8889 8.11111 10.8889C7.19064 10.8889 6.44444 10.1427 6.44444 9.22222C6.44444 8.30175 7.19064 7.55556 8.11111 7.55556C9.03159 7.55556 9.77778 8.30175 9.77778 9.22222Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5556 9.22222C17.5556 10.1427 16.8094 10.8889 15.8889 10.8889C14.9684 10.8889 14.2222 10.1427 14.2222 9.22222C14.2222 8.30175 14.9684 7.55556 15.8889 7.55556C16.8094 7.55556 17.5556 8.30175 17.5556 9.22222Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.13305 18.1752C7.47529 18.4085 7.94188 18.3202 8.17523 17.978C9.02231 16.7356 10.4864 16.0833 12 16.0833C13.5136 16.0833 14.9777 16.7356 15.8248 17.978C16.0581 18.3202 16.5247 18.4085 16.8669 18.1752C17.2092 17.9418 17.2975 17.4752 17.0641 17.133C15.891 15.4124 13.9207 14.5833 12 14.5833C10.0793 14.5833 8.109 15.4124 6.93588 17.133C6.70254 17.4752 6.79082 17.9418 7.13305 18.1752Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadFace);
export default __webpack_public_path__ + "static/media/SadFace.f5d63dd39b31b7e12e7fcea1d971462b.svg";
export { ForwardRef as ReactComponent };